import { render, staticRenderFns } from "./AnnualTrainingForm.vue?vue&type=template&id=79f0844c&scoped=true&"
import script from "./AnnualTrainingForm.vue?vue&type=script&lang=js&"
export * from "./AnnualTrainingForm.vue?vue&type=script&lang=js&"
import style0 from "./AnnualTrainingForm.vue?vue&type=style&index=0&id=79f0844c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f0844c",
  null
  
)

export default component.exports